module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/tiktok-14fdeea95add8de854927e3c93d30719.svg";